/**
 * ShopifySetupGuide — short collapsible help text shown inside the Shopify
 * connection popup (`MCP.tsx`), explaining both credential flows:
 *   - legacy admin-created custom app → static Admin API access token, and
 *   - post-2026 Shopify Dev Dashboard app → Client ID + Client Secret
 *     (Shopify removed "Develop apps" on 2026-01-01; Dev Dashboard apps issue
 *     no static token — tara mints the short-lived Admin token itself).
 *
 * NOTE: all class names are namespaced `.shopifyIntegration*` — this repo
 * bundles every SCSS file globally, so generic names would collide app-wide.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../styles/pages/MCP/shopifyIntegration.scss';

const ShopifySetupGuide = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='shopifyIntegrationGuide'>
      <button
        type='button'
        className='shopifyIntegrationGuide__toggle'
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
      >
        <span
          className={`shopifyIntegrationGuide__toggle--arrow ${
            isOpen ? 'shopifyIntegrationGuide__toggle--arrow-open' : ''
          }`}
        >
          ▸
        </span>
        {t('Shopify-GuideToggle')}
      </button>
      {isOpen && (
        <div className='shopifyIntegrationGuide__body'>
          <p className='shopifyIntegrationGuide__body--steps'>
            <strong>{t('Shopify-GuideLegacyTitle')}</strong>{' '}
            {t('Shopify-GuideSteps')}
          </p>
          <p className='shopifyIntegrationGuide__body--steps'>
            <strong>{t('Shopify-GuideNewFlowTitle')}</strong>{' '}
            {t('Shopify-GuideNewFlow')}
          </p>
          <p className='shopifyIntegrationGuide__body--gdpr'>
            {t('Shopify-GuideGdpr')}
          </p>
        </div>
      )}
    </div>
  );
};

export default ShopifySetupGuide;
